<template>
<div id="app">
    <v-app id="inspire" light>
        <v-card flat>
            <v-layout row wrap>
                <v-toolbar size="120px" dark color="info">
                    <v-toolbar-title class="baslikfont">Raporlar</v-toolbar-title>
                </v-toolbar>
                <v-container fluid="">
                    <v-layout row wrap>
                        <v-flex xs12 sm12 md12>
                            <v-form ref="musteriaraform" lazy-validation>
                                <v-layout row wrap>
                                    <v-flex xs12 sm3 md5>
                                        <v-autocomplete hide-details="" :items="musteriitems" item-text="MusteriAdi" item-value="MusteriID" clearable label="Müşteri Ara" v-model="Sorunlar.MustID"></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm4 md2>
                                        <tarihim :etiket="'Alış Tarihi'" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']" v-model="Sorunlar.BaslangicTarih"></tarihim>
                                    </v-flex>
                                    <v-flex xs12 sm4 md2>
                                        <tarihim :etiket="'Bitiş Tarihi'" :detaygizle="false" v-bind:defaultvalue="'ok'" :rules="[v => !!v || 'Lütfen tarih seçiniz']" v-model="Sorunlar.BitisTarih"></tarihim>
                                    </v-flex>
                                    <v-flex xs12 sm4 md2>
                                        <v-autocomplete :items="itemsSorunTip" label="Sorun Türü" item-value="SorunTipID" item-text="Aciklama"></v-autocomplete>
                                    </v-flex>
                                    <v-flex xs12 sm1 md1>
                                        <v-btn @click="SorunCek()" color="info" fab small="" dark>
                                            <v-icon>refresh</v-icon>
                                        </v-btn>
                                    </v-flex>
                                </v-layout>
                            </v-form>
                        </v-flex>
                    </v-layout>
                </v-container>
                <template>
                    <v-container>
                        <v-expansion-panel focusable>
                            <v-expansion-panel-content>
                                <template v-for="item in sorunitems" v-slot:header>
                                    <v-layout v-bind:key="item.SorunID" align-center row spacer>
                                        <v-flex sm5 md3 hidden-xs-only>
                                            <span class="grey--text">
                                                Müşteri Kodu:{{item.MusteriBilgi.MusteriKod}}
                                            </span>
                                        </v-flex>
                                        <v-flex no-wrap xs5 sm3>
                                            <span class="grey--text" v-html="'Müşteri Adı:' +item.MusteriBilgi.MusteriAdi.substring(0,40)">
                                                Firma Adı:
                                            </span>
                                            <strong></strong>
                                        </v-flex>
                                        <v-flex class="grey--text" ellipsis hidden-sm-and-down>
                                            <span class="grey--text">
                                                Adet:{{Sorun.length}}
                                            </span>
                                        </v-flex>
                                        <v-flex class="grey--text" ellipsis hidden-sm-and-down>
                                            <span class="grey--text">
                                                Toplam Süre:{{saatim}}
                                            </span>
                                        </v-flex>
                                    </v-layout>
                                </template>
                                <v-card xs12 sm6 md12>
                                    <template v-for="(item,i) in sorunitems"  @click="destekList(item.SorunID)">
                                        <v-layout v-bind:key="i">
                                           <!-- <a @click="destekList(item.SorunID)"> -->
                                                <v-expansion-panel>
                                                    <v-expansion-panel-content>
                                                        <template v-slot:header>
                                                            <v-card flat>
                                                                <v-card-title>
                                                                    <span class="grey--text">
                                                                        Sorun Tip:{{item.SorunTip.Aciklama}}
                                                                    </span>
                                                                </v-card-title>
                                                            </v-card>
                                                            <v-card flat>
                                                                <v-card-title>
                                                                    <span class="grey--text">
                                                                        Sorun:{{item.Aciklama}}
                                                                    </span>
                                                                </v-card-title>
                                                            </v-card>
                                                            <v-card flat>
                                                                <v-card-title>
                                                                    <span class="grey--text">
                                                                        Arayan:{{item.Arayan}}
                                                                    </span>
                                                                </v-card-title>
                                                            </v-card>
                                                            <v-card flat>
                                                                <v-card-title>
                                                                    <span class="grey--text">
                                                                        Çözecek:{{item.CozecekBilgi.AdSoyad}}
                                                                    </span>
                                                                </v-card-title>
                                                            </v-card>
                                                            <v-card flat>
                                                                <v-card-title>
                                                                    <span class="grey--text">
                                                                        Alış Tarihi:{{item.AlisTarihi | dateformat}}
                                                                    </span>
                                                                </v-card-title>
                                                            </v-card>
                                                            <v-card flat>
                                                                <v-card-title>
                                                                    <span class="grey--text">
                                                                        Toplam Süre:{{saatler[i]}}
                                                                    </span>
                                                                </v-card-title>
                                                            </v-card>
                                                        </template>
                                                        <v-card>
                                                            <template v-for="item in destekitems">
                                                                <v-layout v-bind:key="item.DestekID">
                                                                    <v-expansion-panel>
                                                                        <v-expansion-panel-content>
                                                                            <template v-slot:header>
                                                                                <v-layout align-center row spacer>
                                                                                    <v-flex sm5 md3 hidden-xs-only>
                                                                                        <span class="grey--text">
                                                                                            Destek Tip:{{item.DestekTip.Aciklama}}
                                                                                        </span>
                                                                                    </v-flex>
                                                                                    <v-flex no-wrap xs5 sm3>
                                                                                        <span class="grey--text">
                                                                                            Çözüm Tip:{{item.CozumTip.Aciklama}}
                                                                                        </span>
                                                                                    </v-flex>
                                                                                    <v-flex class="grey--text" ellipsis hidden-sm-and-down>
                                                                                        <span class="grey--text" v-html="'Destek:' +item.DestekAciklama.substring(0,20)">
                                                                                        </span>
                                                                                    </v-flex>
                                                                                    <v-flex class="grey--text" ellipsis hidden-sm-and-down>
                                                                                        <span class="grey--text">
                                                                                            Destek Başlangıç Tarihi:{{item.DestekBaslangicTarih | dateformat}}
                                                                                        </span>
                                                                                    </v-flex>
                                                                                    <v-flex class="grey--text" ellipsis hidden-sm-and-down>
                                                                                        <span class="grey--text">
                                                                                            Saat Başlangıç:{{item.SaatBaslangic | timeformat}}
                                                                                        </span>
                                                                                    </v-flex>
                                                                                    <v-flex class="grey--text" ellipsis hidden-sm-and-down>
                                                                                        <span class="grey--text">
                                                                                            Saat Bitiş:{{item.SaatBitis | timeformat}}
                                                                                        </span>
                                                                                    </v-flex>
                                                                                </v-layout>
                                                                            </template>
                                                                            <v-card>
                                                                            </v-card>
                                                                        </v-expansion-panel-content>
                                                                    </v-expansion-panel>
                                                                </v-layout>
                                                            </template>
                                                        </v-card>
                                                    </v-expansion-panel-content>
                                                </v-expansion-panel>
                                        </v-layout>
                                    </template>
                                </v-card>
                            </v-expansion-panel-content>
                        </v-expansion-panel>
                    </v-container>
                </template>

                <v-snackbar :timeout="timeout" :top="y === 'top'" :bottom="y === 'bottom'" :right="x === 'right'" :left="x === 'left'" :multi-line="mode === 'multi-line'" :vertical="mode === 'vertical'" v-model="snackbar">
                    {{ text1 }}
                    <v-btn flat color="pink" @click.native="snackbar = false">Kapat</v-btn>
                </v-snackbar>
            </v-layout>
        </v-card>
    </v-app>
</div>
</template>

<script>
import auth from '../../../api/auth'
import helpers from "@/components/app/customcomp/helpers.js"
import tarihim from '../customcomp/tarihim'
export default {
    data() {
        return {
            search: '',
            minutes: [],
            saatler: [],
            saatim: '',
            saatHesaplaList: [],
            destekListener: '',
            selected: [],
            destekitems: [],
            snackbar: false,
            y: 'top',
            x: 'right',
            mode: '',
            timeout: 6000,
            text1: '',
            loading: false,
            load1: '',
            search: '',
            itemsSorunTip: [],
            sorunitems: [],
            musteriitems: [],
            Raporlar: {
                AlisTarihiBas: null,
                AlisTarihiBit: null,
            },
            Sorunlar: {
                MustID: null,
                UserID: null,
                BaslangicTarih: null,
                BitisTarih: null,
                Cozuldu: null,
                UcretliDestek: null,
            },
            Sorun: {
                SorunID: null,
                MusteriBilgi: {
                    MusteriID: null,
                    MusteriKod: null,
                    MusteriAdi: null,
                },
                UserBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                AlisTarihi: null,
                Arayan: null,
                ArayanMail: null,
                CozecekBilgi: {
                    UserID: null,
                    Email: null,
                    AdSoyad: null,
                },
                Cozuldu: null,
                UrunBilgi: {
                    Ref: null,
                    UrunAdi: null,
                    UrunAciklama: null,
                    Aciklama: null,
                },
                SorunAciklama: null,
                SorunTip: {
                    SorunTipID: null,
                    Aciklama: null,
                },
                BaslangicSaat: null,
                BitisSaat: null,
                BeklenenYer: {
                    Id: null,
                    ParentId: null,
                    Aciklama: null,
                    Yetki: null,
                },
                UcretliDestek: null,
                UcretliDestekAciklama: null,
            },
        }
    },
    beforeMount: beforeMount,
    components: {
        tarihim
    },
    filters: {

        dateformat: function (t) {
            return helpers.dateformat(t);
        },
        timeformat: function (c) {
            return helpers.timeformat(c);
        },

    },

    methods: {
        problemTuru: problemTuru,
        musteriler: musteriler,
        SorunCek: SorunCek,
         destekList: function(val){
        var userparams = {
        SorunID: val,
        UserID: null,
        BaslangicTarih: this.Sorunlar.BaslangicTarih,
        BitisTarih: this.Sorunlar.BitisTarih,
    }
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/SupportList', userparams, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.destekitems = response.body
        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        } else {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        }
    })
    }

    },
}

function beforeMount() {
    this.musteriler()
    this.problemTuru()
    this.Raporlar.AlisTarihiBas = helpers.getDateNow()
    this.Raporlar.AlisTarihiBit = helpers.getDateNow()
}

function musteriler() {
    this.$http.post(auth.API_URL + 'api/Awed/CustomerReportList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {

        this.musteriitems = response.body
        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        } else {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        }
    })

}


function SorunCek() {
    var params = {
        MusteriID: this.Sorunlar.MustID,
        UserID: null,
        BaslangicTarih: this.Sorunlar.BaslangicTarih,
        BitisTarih: this.Sorunlar.BitisTarih,
        Cozuldu: null,
        UcretliDestek: null,
    }

    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemsList', params, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.Sorun = response.body
        this.sorunitems = response.body
        var sumHours = 0;
        var sumMinutes = 0;
        Object.keys(this.sorunitems).forEach(key => {
            var Saat = {
                BasSaat: this.sorunitems[key].BaslangicSaat,
                BitSaat: this.sorunitems[key].BitisSaat,
            }
            var date1 = new Date(Saat.BasSaat)
            var date2 = new Date(Saat.BitSaat)
            var res = Math.abs(date1 - date2) / 1000
            var hours = Math.floor(res / 3600) % 24;
            var last = Math.floor(res / 60) % 60
            this.minutes = hours + ':' + last
            this.saatler.push(this.minutes)
            var sayim = this.minutes.split(':')
            sumHours += parseInt(sayim[0])
            sumMinutes += parseInt(sayim[1])
            var dakika = Math.floor(sumMinutes / 60) % 60
            if (dakika > 60) {
                sumHours += dakika
            }
            //console.log("AAAAAAAAAAAAAAAAAA" + this.minutes)
            var saat = sumHours + dakika
            this.saatim = saat + "Saat" + "     " + sayim[1] + "Dakika"
        });
        this.progress = false
    }, (response) => {
        if (response.status === 0) {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        } else {
            this.text1 = 'Service Unavailable-CustomerAllList'
            this.snackbar = true
            this.progress = false
        }
    })
}

function problemTuru() {
    this.$http.post(auth.API_URL + 'api/ProblemsSupports/ProblemTypeList', null, {
        headers: {
            'Authorization': 'Bearer ' + auth.getAuthHeader()
        }
    }).then((response) => {
        this.itemsSorunTip = response.body
    }, (response) => {
        if (response.Status === true) {
            this.text1 = response.body.ResponseMessage
            this.snackbar = true
        } else {
            this.text1 = response.statusText
            this.snackbar = true
        }
    })
}
</script>

<style>
</style>
